(() => {
  angular
    .module('gm.common.user.profile', [
    ])
    .factory('GmyProfile', GmyProfile);

  function GmyProfile(
    gmApi,
    GmyCrypto
  ) {
    'ngInject';

    const PROFILE_TYPES = {
      PERSONAL: 'personal',
      BUSINESS: 'business'
    };

    return {
      PROFILE_TYPES,
      getEmailSettings,
      logout,
      refreshAuthToken,
      signIn,
      signUp,
      updateEmailSettings,
      updatePassword,
      updatePhoneNumber,
      updateProfile,
    };

    function getEmailSettings() {
      return gmApi.get('users/settings/notifications/email');
    }

    function logout() {
      return gmApi.delete('users/sessions', { auth: true });
    }

    function refreshAuthToken() {
      return gmApi.put('users/sessions', {}, { auth: true, token: true });
    }

    function signIn({ email, password, rememberMe, checkIp }, twoFactAuth, captcha) {
      const data = {
        email,
        password: GmyCrypto.truncatedSHA512(password),
        rememberMe: !!rememberMe,
        checkIp: !!checkIp
      };

      return gmApi.post('users/sessions', data, {
        token: true,
        twoFactAuth,
        captcha
      });
    }

    function signUp(email, password, type, captcha, alreadyHashed) {
      const data = {
        email,
        password: alreadyHashed ? password : GmyCrypto.truncatedSHA512(password),
        accountType: type,
        skipEmailVerification: true
      };

      return gmApi.post('users', data, {
        token: true,
        captcha
      });
    }

    function updateEmailSettings(settings) {
      return gmApi.put('users/settings/notifications/email', settings, {
        auth: true
      });
    }

    function updatePassword(oldPassword, newPassword) {
      return gmApi.put('users/password', {
        oldPassword: GmyCrypto.truncatedSHA512(oldPassword),
        newPassword: GmyCrypto.truncatedSHA512(newPassword)
      }, {
        auth: true
      });
    }

    function updatePhoneNumber(phone) {
      return gmApi.post('users/phone', {
        phone
      }, {
        auth: true
      });
    }

    /**
     * Update profile
     * @param {Object} data
     * @returns {Promise}
     */
    function updateProfile(data) {
      const fields = [
        'firstName',
        'lastName',
        'dateOfBirth',
        'street',
        'streetLine2',
        'city',
        'stateOrProvince',
        'zipOrPostalCode',
        'countryCode',
        'ssn'
      ];

      const infoData = fields.reduce((info, field) => {
        info[field] = data[field] || '';

        return info;
      }, {});

      return gmApi.post('users/profile', infoData, {
        auth: true
      });
    }
  }
})();
